import { render, staticRenderFns } from "./PressableButton.vue?vue&type=template&id=99878bf0&"
import script from "./PressableButton.vue?vue&type=script&lang=js&"
export * from "./PressableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports